export const getFullImageUrl = (path) => {
  if (!path) return ""
  const base = process.env.REACT_APP_API_BASE_URL.replace("/api", "")
  return `${base}${path}`
}
